/**
 * @author Camilo Ramirez
 * @Copyright (c)  Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import ITipoConteoAuditoria from './entidades/ITipoConteoAuditoria';

export default class ModeloTipoConteoAuditoria {
    public consultarTipoConteoAuditoria() {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocio.get('TipoConteoAuditoria/ConsultarListaTipoConteoAuditoria'),
            true
        );
    }
    public crearTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocio.post('TipoConteoAuditoria/GuardarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
    public editarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocio.put('TipoConteoAuditoria/EditarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
    public eliminarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        return manejadorRest<IRespuesta<ITipoConteoAuditoria>>(
            () => negocio.delete('TipoConteoAuditoria/EliminarTipoConteoAuditoria', tipoConteoAuditoria),
            true
        );
    }
}
